export const C = {
  navy: "#0A1929",
  navyLight: "#1A2938",
  coral: "#D4A574",
  coralLight: "#E8D4C0",
  white: "#FFFFFF",
  offWhite: "#FAFBFC",
  gray50: "#F7F8F9",
  gray100: "#EEF0F2",
  gray200: "#E0E4E8",
  gray300: "#C0C8D0",
  gray400: "#9CA3B0",
  gray500: "#6B7280",
  gray600: "#4B5563",
  font: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  mono: "'JetBrains Mono', 'SF Mono', monospace",
};
